import type { ReactNode } from 'react';
import { useApp, type Screen } from '@/state/store';
import { Icon, type IconName } from './Icon';

const nav: { screen: Screen; label: string; icon: IconName }[] = [
  { screen: 'home', label: '훈련 둘러보기', icon: 'home' },
  { screen: 'journey', label: '42일 이야기', icon: 'spark' },
  { screen: 'stories', label: '이야기 속으로', icon: 'book' },
  { screen: 'records', label: '나의 기록', icon: 'chart' },
  { screen: 'calibration', label: '기기 설정', icon: 'settings' },
  { screen: 'researcher', label: '연구자 도구', icon: 'flask' },
];
export function AppShell({ children }: { children: ReactNode }) {
  const screen = useApp(s => s.screen), go = useApp(s => s.go);
  const title = nav.find(n => n.screen === screen)?.label ?? ({ tutorial: '사용 가이드', interpretation: '해석 훈련', session: '주의 훈련', dashboard: '주의 과제 상세' } as Partial<Record<Screen, string>>)[screen] ?? '훈련 둘러보기';
  return <div className="app-shell">
    <aside className="sidebar">
      <button className="brand" onClick={() => go('home')} aria-label="다른 시선 홈"><span className="brand-mark"><Icon name="eye" size={31} /></span><span>다른 시선<small>CBMI</small></span></button>
      <nav aria-label="주 메뉴">{nav.map(n => <button key={n.screen} className={`nav-item ${screen === n.screen || (n.screen === 'home' && ['session', 'interpretation', 'tutorial'].includes(screen)) ? 'active' : ''}`} aria-current={screen === n.screen ? 'page' : undefined} onClick={() => go(n.screen)}><Icon name={n.icon} />{n.label}</button>)}</nav>
      <div className="sidebar-foot"><span className="status-dot" />팀 시연 · 연구용 프로토타입<small>작은 연습으로 넓어지는 시선</small></div>
    </aside>
    <div className="workspace"><header className="topbar"><div className="breadcrumb"><Icon name="home" size={15} /><span>/</span>{title}</div><button className="text-button" onClick={() => go('tutorial')}><Icon name="book" size={17} />사용 가이드</button></header><main id="main-content">{children}</main><footer className="app-footer">다른 시선 <span>이 기기에 기록이 저장됩니다 · 시연용 콘텐츠</span></footer></div>
  </div>;
}
